// Geboortevenster · Tekstpassing van bloklabels (gedeeld door de horizontale en de verticale lanes).
// Overzicht van de feature: EgituraPlatform/docs/human-design/hd-birth-window.md

import { HdPropertyLaneLabelPart } from './hd-property-lanes.models';

/** Gemiddelde tekenbreedte van het 11px-bloklabel; ruim genomen zodat labels nooit over de rand lopen. */
export const HD_PROPERTY_LANE_CHAR_PX = 6.3;
export const HD_PROPERTY_LANE_BLOCK_PADDING_PX = 5;

/** Past de labeldelen in de beschikbare lengte (px): volledig, afgekort met "…" of leeg. */
export function fitLaneLabelParts(parts: readonly HdPropertyLaneLabelPart[], lengthPx: number): HdPropertyLaneLabelPart[] {
  const available = lengthPx - 2 * HD_PROPERTY_LANE_BLOCK_PADDING_PX;
  const maxChars = Math.floor(available / HD_PROPERTY_LANE_CHAR_PX);
  if (maxChars < 2) return [];
  const result: HdPropertyLaneLabelPart[] = [];
  let used = 0;
  for (let i = 0; i < parts.length; i++) {
    const text = (i > 0 ? ' · ' : '') + parts[i].text;
    if (used + text.length <= maxChars) {
      result.push({ text, tone: parts[i].tone });
      used += text.length;
      continue;
    }
    const room = maxChars - used - 1;
    if (room >= 2) result.push({ text: `${text.slice(0, room)}…`, tone: parts[i].tone });
    else if (result.length === 0) return [];
    break;
  }
  return result;
}

/** Kleuren van een accent-blok per staat: geboorte vol, zelfde als tint, anders enkel een rand. */
export function laneAccentColors(accent: string, state: 'birth' | 'same' | 'different'): { fill: string; stroke: string; textFill: string } {
  if (state === 'birth') return { fill: accent, stroke: accent, textFill: '#ffffff' };
  if (state === 'same') return { fill: hexToRgba(accent, 0.18), stroke: accent, textFill: accent };
  return { fill: 'var(--hd-surface-row-b, #f2efe8)', stroke: hexToRgba(accent, 0.6), textFill: 'var(--primary, #3c4650)' };
}

export function hexToRgba(hex: string, alpha: number): string {
  const match = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!match) return hex;
  const value = parseInt(match[1], 16);
  return `rgba(${(value >> 16) & 255}, ${(value >> 8) & 255}, ${value & 255}, ${alpha})`;
}

/** Minuut van de dag op de geboorteklok (niet de browserklok). */
export function birthClockMinuteOfDay(ms: number, timeZone: string | undefined): number {
  const date = new Date(ms);
  try {
    const parts = new Intl.DateTimeFormat('en', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: timeZone || 'UTC' })
      .formatToParts(date);
    const hour = Number(parts.find(part => part.type === 'hour')?.value ?? 0);
    const minute = Number(parts.find(part => part.type === 'minute')?.value ?? 0);
    return hour * 60 + minute;
  } catch {
    return date.getUTCHours() * 60 + date.getUTCMinutes();
  }
}
